import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import EventModel from '../EventModel';

/**
 * Represents AccountCreationEventModel
 */
export default class AccountCreationEventModel extends EventModel {
	public accountCustomerId: string;
	public visitorGender: string;
	public newsletterSubsription: boolean;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		this.accountCustomerId = data.customerNo;

		if (data.gender) {
			this.visitorGender = data.gender === 2 ? 'woman' : 'men';
		}

		// Keep this name [newsletterSubsription] with typo
		this.newsletterSubsription = data.newsletter;
	}
};
